import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getStringDate } from "app/components/InstancePicker/helpers";
import { InstanceShowing } from "app/components/InstancePicker/types";
import Button from "app/storybookComponents/Button";

interface Props {
  onConfigureResults: () => void;
  hasEnoughResults?: boolean;
  isLatestInstance?: boolean;
  instanceShowing: InstanceShowing | null;
  entity?: string;
}

export default function InstanceBanner({
  onConfigureResults,
  hasEnoughResults,
  isLatestInstance,
  instanceShowing,
  entity = "department",
}: Readonly<Props>) {
  const getBannerText = () => {
    if (
      instanceShowing?.startDate &&
      instanceShowing?.endDate &&
      !isLatestInstance
    ) {
      const startDateString = getStringDate(
        new Date(instanceShowing.startDate)
      );
      const endDateString = getStringDate(new Date(instanceShowing.endDate));

      return `This report includes all the response from TEAMscans launched for this ${entity} from ${startDateString} to ${endDateString}.`;
    }

    return `This report includes all responses from the most recent instance of the TEAMscan launched in this ${entity}.`;
  };

  return (
    <div
      className={`warning-banner${
        isLatestInstance && hasEnoughResults ? " blue " : " "
      }d-flex align-items-center justify-content-between`}
      style={{
        padding: "12px 16px",
      }}
    >
      <p>
        <b>{getBannerText()}</b>
      </p>
      <Button
        onClick={() => {
          onConfigureResults();
        }}
      >
        View past results <FontAwesomeIcon icon="arrow-right" />
      </Button>
    </div>
  );
}
